import { PropsWithChildren } from 'react';
import { TableThead } from '@mantine/core';

export const TouringCardTableHead: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return <TableThead>{children}</TableThead>;
};
